// extracted by mini-css-extract-plugin
module.exports = {"footerHeader":"FooterHeader_footerHeader__ktDYE","secondaryLink":"FooterHeader_secondaryLink__MU9Ro","footerPhoneNumber":"FooterHeader_footerPhoneNumber__0zYBy"};